<template>
  <div id="box--camera--container">
    <div id="box-camera">
      <!-- Camera sensor -->
      <canvas id="camera--canvas"></canvas>
      <!-- Camera view -->
      <video id="camera--video" autoplay playsinline muted></video>

      <!-- Canvas landmarks -->
      <!-- <canvas id="camera-overlay"></canvas> -->

      <!-- Camera output -->
      <img src alt id="camera--output" style="display: none;" />

      <!-- Camera trigger -->
      <button id="camera--trigger">Tirar foto</button>

      <!-- Loading ... -->
      <div id="box--loading" style="display: none;">
        <svg
          id="loading"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          style="margin:auto;background:transparent;display:block;"
          width="80px"
          height="80px"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
        >
          <circle
            cx="50"
            cy="50"
            fill="none"
            stroke="#cccccc"
            stroke-width="10"
            r="35"
            stroke-dasharray="164.93361431346415 56.97787143782138"
            transform="rotate(304.35 50 50)"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              repeatCount="indefinite"
              dur="1s"
              values="0 50 50;360 50 50"
              keyTimes="0;1"
            />
          </circle>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import adapter from 'webrtc-adapter'
import platform from 'platform'
export default {
  data () {
    return {
      constraints: {
      },
      constraintsBase: {
        video: {
          facingMode: 'user'
        },
        audio: false
      },
      videoOrientation: null,
      track: null,
      cameraOpen: null,
      svgMask: null,
      defs: null,
      style: null,
      groupMain: null,
      groupMask: null,
      pathBackground: null,
      pathFocus: null,
      stream: null,
      aspectRatioVideo: 1280 / 720,
      videoWidth: 0,
      videoHeight: 0,
      mWidth: 0,
      mHeight: 0,
      resolutionWidth: 1280,
      resolutionHeight: 720,
      defaultConstraints: {
        video: {
          width: {
            min: 640,
            ideal: 1280,
            max: 1920
          },
          height: {
            min: 480,
            ideal: 720,
            max: 1080
          }
        }
      },
      Orientation: {
        PORTRAIT: 1,
        LANDSCAPE: 2
      },
      buttonCapture: null,
      stopAfterTake: true
    }
  },
  mounted () {
    // video da abertura da câmera
    this.cameraVideo = document.querySelector('#camera--video')
    // imagem capturada
    this.cameraOutput = document.querySelector('#camera--output')
    // canvas utilizado na captura
    this.cameraCanvas = document.querySelector('#camera--canvas')
    // canvas overlay (landmarks)
    // this.cameraOverlay = document.querySelector('#camera-overlay')
    // botão de captura
    this.buttonCapture = document.querySelector('#camera--trigger')
    // loading
    this.boxLoading = document.querySelector('#box--loading')
    // box da câmera
    this.boxCamera = document.querySelector('#box-camera')
    this.init()
    let _self = this
    this.$bus.$on('stopCameraProcess', () => {
      _self.stopAfterTake = true
      this.buttonCapture.disabled = false
    })
  },
  methods: {
    isMobile () {
      return navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i) !== null
    },
    isSafari () {
      return /constructor/i.test(window.HTMLElement) ||
      (function (p) {
        return p.toString() === '[object SafariRemoteNotification]'
      })(!window['safari'])
    },
    addClickEvent () {
      if (this.buttonCapture) {
        this.buttonCapture.onclick = this.takePicture
      }
    },
    takePicture () {
      if (this.cameraOpen) {
        // canvas
        this.cameraCanvas.width = this.cameraVideo.videoWidth
        this.cameraCanvas.height = this.cameraVideo.videoHeight
        this.cameraCanvas.getContext('2d').drawImage(this.cameraVideo, 0, 0)

        // image
        this.cameraOutput.src = this.cameraCanvas.toDataURL('image/jpeg')
        this.cameraOutput.style.display = 'block'

        // stop tracking
        if (this.track) {
          this.track.stop()
        }

        // hide mask
        this.setVisibilityAfterTake()

        // set camera status
        this.cameraOpen = false
        let response = {
          success: true,
          base64: this.cameraOutput.src,
          message: 'câmera aberta com sucesso',
          deviceInfo: {
            constraints: this.constraints,
            platform: platform,
            browser: {
              name: adapter.browserDetails.browser,
              version: adapter.browserDetails.version
            }
          }
        }
        this.stopAfterTake = false
        this.buttonCapture.disabled = true
        this.afterTakePicture()
        // event new image
        this.$bus.$emit('capturedImage', response)
      } else {
        this.buttonCapture.disabled = false
        this.buttonCapture.textContent = 'Tirar foto'
        this.stopAfterTake = true
        // hides captured image
        this.setVisibilityOpenCamera()
        // start camera again
        this.startCamera()
      }
    },
    afterTakePicture () {
      let _self = this
      _self.buttonCapture.textContent = 'Aguarde.'
      setTimeout(function () {
        _self.buttonCapture.textContent = 'Aguarde..'
        setTimeout(function () {
          _self.buttonCapture.textContent = 'Aguarde...'
          setTimeout(function () {
            if (_self.stopAfterTake) {
              _self.afterTakePicture()
            }
          }, 2000)
        }, 2000)
      }, 2000)
    },
    setVisibilityOpenCamera () {
      this.cameraOutput.style = 'display: none;'

      // show mask
      this.svgMask.style.display = 'unset'

      // show camera video
      this.cameraVideo.style.display = 'unset'

      // hides box loading
      this.boxLoading.style.display = 'none'

      // original text buttom
      this.buttonCapture.textContent = 'Tirar foto'
    },
    setVisibilityAfterTake () {
      this.svgMask.style.display = 'none'

      // show loading
      this.boxLoading.style.display = 'unset'

      // change text button camera
      this.buttonCapture.textContent = 'Tirar outra'

      // hide video
      this.cameraVideo.style.display = 'none'

      this.resizeImageOut()
    },
    resizeImageOut () {
      if (this.isMobile()) {
        this.cameraOutput.style.width = '100%'
        this.cameraOutput.style.height = '100%'
        this.cameraOutput.style['object-fit'] = 'cover'
        this.cameraOutput.style.top = ''
        this.cameraOutput.style.left = ''
      } else {
        this.cameraOutput.style['object-fit'] = ''
        let aspectRatioScreen = 0
        aspectRatioScreen = this.boxCamera.offsetWidth / this.boxCamera.offsetHeight

        // faixa preta emcima e embaixo
        if (this.aspectRatioVideo > aspectRatioScreen) {
          this.videoHeight = this.boxCamera.offsetWidth / this.aspectRatioVideo
          this.videoWidth = this.boxCamera.offsetWidth
        } else {
          // faixa preta nas laterais
          this.videoHeight = this.boxCamera.offsetHeight
          this.videoWidth = this.boxCamera.offsetHeight * this.aspectRatioVideo
        }

        // ajusta a posicao (left x top)
        if (this.boxCamera.offsetWidth > this.videoWidth) {
          this.cameraOutput.style.left = (this.boxCamera.offsetWidth - this.videoWidth) / 2
          this.cameraOutput.style.top = ''
        } else if (this.boxCamera.offsetHeight > this.videoHeight) {
          this.cameraOutput.style.left = ''
          this.cameraOutput.style.top = (this.boxCamera.offsetHeight - this.videoHeight) / 2
        }

        let aspectRatioImg = this.cameraOutput.offsetWidth / this.cameraOutput.offsetHeight

        // faixa preta emcima e embaixo
        if (aspectRatioImg > aspectRatioScreen) {
          // set a captured image
          this.cameraOutput.style.width = this.videoWidth
          this.cameraOutput.style.height = null
        } else {
          // faixa preta nas laterais
          this.cameraOutput.style.width = null
          this.cameraOutput.style.height = this.videoHeight
        }
      }
    },
    calcBtnCapturePos () {
      // diferença entre o video e a area visivel (na web fica com a faixa preta caso ultrapasse a area do video)
      let diff = this.boxCamera.offsetHeight - this.videoHeight
      let bottom = diff > 0 ? diff / 2 : 0 + 20
      this.buttonCapture.style.bottom = `${bottom}px`
      this.buttonCapture.style.display = 'inline-block'
    },
    orientationChange () {
      this.setOrientation()
      window.scrollTo(0, document.body.scrollHeight)
      this.updateView()
    },
    updateView () {
      if (this.cameraOpen) {
        this.loadMask()
      } else if (this.cameraOutput.src !== '') {
        // has image ?
        this.resizeImageOut()
      }
      this.calcBtnCapturePos()
      this.setMobileStyle()
    },
    addEventResize () {
      let _self = this
      window.addEventListener('resize', (e) => {
        _self.setOrientation()
        _self.updateView()
      })
    },
    addEventPlay () {
      this.cameraVideo.addEventListener('play', () => {
        this.cameraOpen = true
      })
    },
    loadMask () {
      // parameters -----------------------------------
      let mBoxWidth = this.cameraVideo.offsetWidth
      let mBoxHeight = this.cameraVideo.offsetHeight
      let borderColor = '#fff'
      let borderWidth = 5
      let backgroundOpacity = '0.7'
      // parameters -----------------------------------

      let currentAspectRatio = 0

      if (mBoxWidth > mBoxHeight) {
        this.videoOrientation = this.Orientation.LANDSCAPE
      }

      // video proportion
      if (this.isMobile()) {
        this.videoWidth = this.cameraVideo.offsetWidth
        this.videoHeight = this.cameraVideo.offsetHeight
      } else {
        currentAspectRatio = this.cameraVideo.offsetWidth / this.cameraVideo.offsetHeight

        // faixa preta emcima e embaixo
        if (this.aspectRatioVideo > currentAspectRatio) {
          this.videoHeight = this.cameraVideo.offsetWidth / this.aspectRatioVideo
          this.videoWidth = this.cameraVideo.offsetWidth
        } else {
          // faixa preta nas laterais
          this.videoHeight = this.cameraVideo.offsetHeight
          this.videoWidth = this.cameraVideo.offsetHeight * this.aspectRatioVideo
        }
      }

      // ajusta o tamanho da máscara com base no video
      // 300px referente a largura, usamos esse valor pois bate com a distância ocular ideal para biometria
      // 480px referente a altura padrão de um rosto
      let factorWidth = (this.videoWidth / this.resolutionWidth) * 300
      let factorHeight = (this.videoHeight / this.resolutionHeight) * 480

      if (this.isMobile()) {
        // no modo portrait levamos em conta a altura e calculamos a largura da máscara
        // quando estamos simulando um dispositivo móvel no navegador a abertura da câmera sempre é landscape
        // porém os lados são cortados no vídeo para dar a impressão de portrait
        // por isso usamos a alttura como referência, por ser o valor real do video (sem cortes)
        if (this.videoOrientation === this.Orientation.PORTRAIT) {
          this.mWidth = factorHeight / (480 / 300)
          this.mHeight = factorHeight
        } else {
          this.mWidth = factorWidth
          this.mHeight = factorHeight
        }
      } else {
        this.mWidth = factorWidth
        this.mHeight = factorHeight
      }

      let exists = document.getElementById('this.svgMask') !== null
      let mBoxXCenter = mBoxWidth / 2
      let mBoxYCenter = mBoxHeight / 2

      let halfMWidth = this.mWidth / 2
      let halfHeight = this.mHeight / 2
      let half14Height = this.mHeight / 4
      let fractionX = 0.15
      let fractionWidthX = halfMWidth * fractionX

      // ---------------
      //      6   7
      //   5         8
      //
      //
      //   4         1
      //      3   2
      // ---------------

      // point 1
      let point1X = mBoxXCenter + halfMWidth
      let point1Y = mBoxYCenter + half14Height

      // point 2
      let point2X = mBoxXCenter + fractionWidthX
      let point2Y = mBoxYCenter + halfHeight

      // point 3
      let point3H = mBoxXCenter - fractionWidthX * 2

      // point 4
      let point4X = mBoxXCenter - halfMWidth
      let point4Y = mBoxYCenter + half14Height

      // point 5
      let point5V = mBoxYCenter - half14Height

      // point 6
      let point6X = mBoxXCenter - fractionWidthX
      let point6Y = mBoxYCenter - halfHeight

      // point 7
      let point7h = fractionWidthX * 2

      // point 8
      let point8X = mBoxXCenter + halfMWidth
      let point8Y = mBoxYCenter - half14Height

      let arcXY = halfMWidth - fractionWidthX

      let mov0 = 'M0,0'
      let v0 = 'V' + mBoxHeight
      let h0 = 'H' + mBoxWidth
      let v1 = 'V0'
      let z0 = 'Z'
      let mov1 = `M${point1X},${point1Y}`
      let arc1 = `A${arcXY},${arcXY},0,0,1,${point2X},${point2Y}`
      let h1 = `H${point3H}`
      let arc2 = `A${arcXY},${arcXY},0,0,1,${point4X},${point4Y}`
      let v2 = `V${point5V}`
      let arc3 = `A${arcXY},${arcXY},0,0,1,${point6X},${point6Y}`
      let h2 = `h${point7h}`
      let arc4 = `A${arcXY},${arcXY},0,0,1,${point8X},${point8Y}`
      let z = 'Z'
      let d = `${mov0}${v0}${h0}${v1}${z0}${mov1}${arc1}${h1}${arc2}${v2}${arc3}${h2}${arc4}${z}`
      let xmlns = 'http://www.w3.org/2000/svg'

      // svg
      if (!this.svgMask) {
        this.svgMask = document.createElementNS(xmlns, 'svg')
      }

      // svg attributes
      this.svgMask.setAttributeNS(
        null,
        'viewBox',
        '0 0 ' + mBoxWidth + ' ' + mBoxHeight
      )
      this.svgMask.setAttributeNS(null, 'width', mBoxWidth)
      this.svgMask.setAttributeNS(null, 'height', mBoxHeight)
      this.svgMask.style.display = 'block'
      this.svgMask.style.position = 'absolute'
      this.svgMask.style.top = '0'
      this.svgMask.style.left = '0'
      this.svgMask.setAttributeNS(null, 'id', `this.svgMask`)

      // definitions
      if (!this.defs) {
        this.defs = document.createElementNS(xmlns, 'defs')
      }

      // style
      if (!this.style) {
        this.style = document.createElementNS(xmlns, 'style')
      }
      this.style.textContent = `.cls-background{opacity:${backgroundOpacity};}.cls-focus{fill:none;stroke:${borderColor};stroke-miterlimit:10;stroke-width:${borderWidth}px;}`

      if (!this.groupMain) {
        this.groupMain = document.createElementNS(xmlns, 'g')
      }

      // main group
      this.groupMain.setAttributeNS(null, 'id', `main`)
      this.groupMain.setAttributeNS(null, 'data-name', `main`)

      // maks group
      if (!this.groupMask) {
        this.groupMask = document.createElementNS(xmlns, 'g')
      }

      this.groupMask.setAttributeNS(null, 'id', `mask`)

      // background
      if (!this.pathBackground) {
        this.pathBackground = document.createElementNS(xmlns, 'path')
      }

      this.pathBackground.setAttributeNS(null, 'id', `background`)
      this.pathBackground.setAttributeNS(null, 'class', `cls-background`)
      this.pathBackground.setAttributeNS(null, 'd', d)

      if (!this.pathFocus) {
        this.pathFocus = document.createElementNS(xmlns, 'rect')
      }

      // focus
      this.pathFocus.setAttributeNS(null, 'id', `focus`)
      this.pathFocus.setAttributeNS(null, 'class', `cls-focus`)
      this.pathFocus.setAttributeNS(null, 'x', point4X)
      this.pathFocus.setAttributeNS(null, 'y', point6Y)
      this.pathFocus.setAttributeNS(null, 'width', this.mWidth)
      this.pathFocus.setAttributeNS(null, 'height', this.mHeight)
      this.pathFocus.setAttributeNS(null, 'rx', arcXY)

      // structure
      if (!exists) {
        this.groupMask.appendChild(this.pathBackground)
        this.groupMask.appendChild(this.pathFocus)
        this.groupMain.appendChild(this.groupMask)
        this.defs.appendChild(this.style)
        this.svgMask.appendChild(this.defs)
        this.svgMask.appendChild(this.groupMain)
        this.boxCamera.appendChild(this.svgMask)
      }
    },
    windowEvent () {
      window.addEventListener('orientationchange', this.orientationChange)
      navigator.mediaDevices.ondevicechange = this.orientationChange
    },
    setOrientation () {
      let orientation =
        (screen.orientation || {}).type ||
        screen.mozOrientation ||
        screen.msOrientation

      // se tem o parametro orientation (chrome, explorer ou mozilla)
      if (orientation) {
        if (
          orientation === 'landscape-primary' ||
          orientation === 'landscape-secondary'
        ) {
          this.videoOrientation = this.Orientation.LANDSCAPE
        } else {
          this.videoOrientation = this.Orientation.PORTRAIT
        }
      } else {
        // caso não exista, possivelmente Safari
        if (this.boxCamera.offsetWidth > this.boxCamera.offsetHeight) {
          this.videoOrientation = this.Orientation.LANDSCAPE
        } else {
          this.videoOrientation = this.Orientation.PORTRAIT
        }
      }
    },
    getConstraints () {
      return this.constraints
    },
    handleError (error) {
      if (error) {
        console.log(
          'navigator.MediaDevices.getUserMedia error: ',
          error.message,
          error.name
        )
      } else {
        console.log('Ooopss algo deu errado na abertura da câmera')
      }
    },
    setAspectRatio () {
      let width = 1280
      let height = 720

      // largura
      if (
        this.constraints &&
        this.constraints.video &&
        this.constraints.video.width &&
        this.constraints.video.width.exact
      ) {
        width = this.constraints.video.width.exact
      }

      // altura
      if (
        this.constraints &&
        this.constraints.video &&
        this.constraints.video.height &&
        this.constraints.video.height.exact
      ) {
        height = this.constraints.video.height.exact
      }

      if (width && height) {
        // landscape
        if (width > height) {
          this.aspectRatioVideo = width / height
        } else {
          // portrait
          this.aspectRatioVideo = height / width
        }
      }
    },
    setConstraint (newConstraints) {
      if (newConstraints) {
        let _constraints = {}
        // copia os dados básicos (video.user e audio)
        Object.assign(_constraints, this.constraints)
        // copia a resolucao nova
        Object.assign(_constraints, newConstraints)
        // define na variavel
        this.constraints = _constraints
        this.setAspectRatio(this.constraints)
      }
    },
    setTrack (mediaStream) {
      if (mediaStream) {
        this.track = mediaStream.getVideoTracks()[0]
        if (this.track.getSettings()) {
          this.resolutionWidth = this.track.getSettings().width
          this.resolutionHeight = this.track.getSettings().height
        }
        this.setConstraint(this.track.getConstraints())
      }
    },
    gotDevices (deviceInfos) {
      for (let i = 0; i !== deviceInfos.length; ++i) {
        const deviceInfo = deviceInfos[i]

        if (deviceInfo.kind === 'videoinput') {
          this.videoSourceInfoId = deviceInfo.deviceId ? deviceInfo.deviceId : undefined
          break
        }
      }
    },
    gotStream (mediaStream) {
      if (mediaStream) {
        // make stream available to console
        this.stream = window.stream = mediaStream
        this.cameraVideo.srcObject = mediaStream
        this.setTrack(mediaStream)
        // Refresh button list in case labels have become available
      }
      return navigator.mediaDevices.enumerateDevices()
    },
    cameraOpenedHandler () {
      try {
        let response = {
          success: true,
          base64: null,
          message: 'câmera aberta com sucesso',
          deviceInfo: {
            constraints: this.constraints,
            platform: platform,
            browser: {
              name: adapter.browserDetails.browser,
              version: adapter.browserDetails.version
            }
          }
        }
        this.$bus.$emit('cameraOpened', response)
        console.log('evento emitido: cameraOpened')
      } catch (error) {
        console.log('erro ao emitir evento: cameraOpened', error)
      }
    },
    cameraErrorHandler (e) {
      let errorMessage = e.toString()
      try {
        let response = {
          success: false,
          base64: null,
          message: errorMessage,
          constraints: this.constraints,
          platform: platform,
          browser: {
            name: adapter.browserDetails.browser,
            version: adapter.browserDetails.version
          }
        }
        this.$bus.$emit('cameraError', response)
        console.log('evento emitido: cameraError')
      } catch (error) {
        console.log('erro ao emitir evento: cameraError', error)
      }
    },
    startCamera () {
      if (window.stream) {
        window.stream.getTracks().forEach((track) => {
          track.stop()
        })
      }

      if (
        !this.constraints ||
        !this.constraints.video ||
        !this.constraints.video.width ||
        !this.constraints.video.height ||
        !this.constraints.video.width.min ||
        !this.constraints.video.width.ideal ||
        !this.constraints.video.width.max ||
        !this.constraints.video.height.min ||
        !this.constraints.video.height.ideal ||
        !this.constraints.video.height.max
      ) {
        // configuração base
        Object.assign(this.constraints, this.constraintsBase)
        // exceto Safari
        if (!this.isSafari()) {
          Object.assign(this.constraints, this.defaultConstraints)
        }
        this.setConstraint(this.constraints)
      }

      navigator.mediaDevices
        .getUserMedia(this.getConstraints())
        .then(this.setMobileStyle())
        .then(this.gotStream)
        .then(this.gotDevices)
        .then(this.loadMask)
        .then(this.calcBtnCapturePos)
        .then(this.cameraOpenedHandler, this.cameraErrorHandler)
        .catch((error) => {
          this.handleError(error)
        })
    },
    setMobileStyle () {
      if (this.isMobile()) {
        this.cameraVideo.style['object-fit'] = 'cover'
      } else {
        this.cameraVideo.style['object-fit'] = ''
      }
    },
    init () {
      // add css top element
      document.querySelector('html').classList.add('camera-selfie-container')
      navigator.mediaDevices.enumerateDevices().catch(this.handleError)
      this.windowEvent()
      this.addClickEvent()
      this.setOrientation()
      this.addEventPlay()
      this.addEventResize()
      this.startCamera()
    }
  }
}
</script>

<style lang="scss" scoped>
.camera-selfie-container {
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  /* make sure to set some focus styles for accessibility */

  :focus {
    outline: 0;
  }

  /* HTML5 display-role reset for older browsers */

  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  body {
    line-height: 1;
  }

  ol,
  ul {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  input[type='search']::-webkit-search-cancel-button,
  input[type='search']::-webkit-search-decoration,
  input[type='search']::-webkit-search-results-button,
  input[type='search']::-webkit-search-results-decoration {
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  input[type='search'] {
    -webkit-appearance: none;
    -moz-appearance: none;
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
    box-sizing: content-box;
  }

  textarea {
    overflow: auto;
    vertical-align: top;
    resize: vertical;
  }

  /**
 * Correct `inline-block` display not defined in IE 6/7/8/9 and Firefox 3.
 */

  audio,
  canvas,
  video {
    display: inline-block;
    *display: inline;
    *zoom: 1;
    max-width: 100%;
  }

  /**
 * Prevent modern browsers from displaying `audio` without controls.
 * Remove excess height in iOS 5 devices.
 */

  audio:not([controls]) {
    display: none;
    height: 0;
  }

  /**
 * Address styling not present in IE 7/8/9, Firefox 3, and Safari 4.
 * Known issue: no IE 6 support.
 */

  [hidden] {
    display: none;
  }

  /**
 * 1. Correct text resizing oddly in IE 6/7 when body `font-size` is set using
 *    `em` units.
 * 2. Prevent iOS text size adjust after orientation change, without disabling
 *    user zoom.
 */

  html {
    font-size: 100%;
    /* 1 */
    -webkit-text-size-adjust: 100%;
    /* 2 */
    -ms-text-size-adjust: 100%;
    /* 2 */
  }

  /**
 * Address `outline` inconsistency between Chrome and other browsers.
 */

  a:focus {
    outline: thin dotted;
  }

  /**
 * Improve readability when focused and also mouse hovered in all browsers.
 */

  a:active,
  a:hover {
    outline: 0;
  }

  /**
 * 1. Remove border when inside `a` element in IE 6/7/8/9 and Firefox 3.
 * 2. Improve image quality when scaled in IE 7.
 */

  img {
    border: 0;
    /* 1 */
    -ms-interpolation-mode: bicubic;
    /* 2 */
  }

  /**
 * Address margin not present in IE 6/7/8/9, Safari 5, and Opera 11.
 */

  figure {
    margin: 0;
  }

  /**
 * Correct margin displayed oddly in IE 6/7.
 */

  form {
    margin: 0;
  }

  /**
 * Define consistent border, margin, and padding.
 */

  fieldset {
    border: 1px solid #c0c0c0;
    margin: 0 2px;
    padding: 0.35em 0.625em 0.75em;
  }

  /**
 * 1. Correct color not being inherited in IE 6/7/8/9.
 * 2. Correct text not wrapping in Firefox 3.
 * 3. Correct alignment displayed oddly in IE 6/7.
 */

  legend {
    border: 0;
    /* 1 */
    padding: 0;
    white-space: normal;
    /* 2 */
    *margin-left: -7px;
    /* 3 */
  }

  /**
 * 1. Correct font size not being inherited in all browsers.
 * 2. Address margins set differently in IE 6/7, Firefox 3+, Safari 5,
 *    and Chrome.
 * 3. Improve appearance and consistency in all browsers.
 */

  button,
  input,
  select,
  textarea {
    font-size: 100%;
    /* 1 */
    margin: 0;
    /* 2 */
    vertical-align: baseline;
    /* 3 */
    *vertical-align: middle;
    /* 3 */
  }

  /**
 * Address Firefox 3+ setting `line-height` on `input` using `!important` in
 * the UA stylesheet.
 */

  button,
  input {
    line-height: normal;
  }

  /**
 * Address inconsistent `text-transform` inheritance for `button` and `select`.
 * All other form control elements do not inherit `text-transform` values.
 * Correct `button` style inheritance in Chrome, Safari 5+, and IE 6+.
 * Correct `select` style inheritance in Firefox 4+ and Opera.
 */

  button,
  select {
    text-transform: none;
  }

  /**
 * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`
 *    and `video` controls.
 * 2. Correct inability to style clickable `input` types in iOS.
 * 3. Improve usability and consistency of cursor style between image-type
 *    `input` and others.
 * 4. Remove inner spacing in IE 7 without affecting normal text inputs.
 *    Known issue: inner spacing remains in IE 6.
 */

  button,
html input[type="button"],

/* 1 */

input[type="reset"],
input[type="submit"] {
    -webkit-appearance: button;
    /* 2 */
    cursor: pointer;
    /* 3 */
    *overflow: visible;
    /* 4 */
  }

  /**
 * Re-set default cursor for disabled elements.
 */

  button[disabled],
  html input[disabled] {
    cursor: default;
  }

  /**
 * 1. Address box sizing set to content-box in IE 8/9.
 * 2. Remove excess padding in IE 8/9.
 * 3. Remove excess padding in IE 7.
 *    Known issue: excess padding remains in IE 6.
 */

  input[type='checkbox'],
  input[type='radio'] {
    box-sizing: border-box;
    /* 1 */
    padding: 0;
    /* 2 */
    *height: 13px;
    /* 3 */
    *width: 13px;
    /* 3 */
  }

  /**
 * 1. Address `appearance` set to `searchfield` in Safari 5 and Chrome.
 * 2. Address `box-sizing` set to `border-box` in Safari 5 and Chrome
 *    (include `-moz` to future-proof).
 */

  input[type='search'] {
    -webkit-appearance: textfield;
    /* 1 */
    -moz-box-sizing: content-box;
    -webkit-box-sizing: content-box;
    /* 2 */
    box-sizing: content-box;
  }

  /**
 * Remove inner padding and search cancel button in Safari 5 and Chrome
 * on OS X.
 */

  input[type='search']::-webkit-search-cancel-button,
  input[type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  /**
 * Remove inner padding and border in Firefox 3+.
 */

  button::-moz-focus-inner,
  input::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  /**
 * 1. Remove default vertical scrollbar in IE 6/7/8/9.
 * 2. Improve readability and alignment in all browsers.
 */

  textarea {
    overflow: auto;
    /* 1 */
    vertical-align: top;
    /* 2 */
  }

  /**
 * Remove most spacing between table cells.
 */

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  html,
  button,
  input,
  select,
  textarea {
    color: #222;
  }

  ::-moz-selection {
    background: #b3d4fc;
    text-shadow: none;
  }

  ::selection {
    background: #b3d4fc;
    text-shadow: none;
  }

  img {
    vertical-align: middle;
  }

  fieldset {
    border: 0;
    margin: 0;
    padding: 0;
  }

  textarea {
    resize: vertical;
  }

  .chromeframe {
    margin: 0.2em 0;
    background: #ccc;
    color: #000;
    padding: 0.2em 0;
  }

  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    font-family: 'Roboto', sans-serif;
  }

  body {
    background-color: rgba(0, 0, 0, 0.7);
    display: block;
    justify-content: center;
    height: 100%;
    width: 100%;
    align-items: center;
    position: fixed;
  }

  .canvas {
    position: absolute;
    z-index: 50;
    margin: 0 auto;
    top: 0;
    bottom: 0;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scaleX(-1);
  }

  @media screen and (min-height: 721px) {
    #box--camera--container {
      padding: 100px 0;
    }
  }
  #box--camera--container {
    position: absolute;
    width: 100%;
    height: 100%;
    display: block;
    background-color: #000;
  }
  #box-camera {
    position: relative;
    overflow: hidden;
    background-color: #000;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  #camera--canvas {
    display: none;
  }

  #svgMask {
    bottom: 0;
  }

  #camera--video,
  #camera--canvas {
    transform: scaleX(-1);
    filter: FlipH;
    width: 100%;
    height: 100%;
  }

  // #camera-overlay {
  //   position: relative;
  //   top: 0px;
  //   left: 0px;
  // }

  #camera--output {
    transform: scaleX(-1);
    filter: FlipH;
    display: block;
    margin: auto;
    position: relative;
    height: 100%;
  }

  #camera--trigger {
    width: 200px;
    background-color: black;
    color: white;
    font-size: 16px;
    border-radius: 30px;
    border: none;
    padding: 15px 20px;
    text-align: center;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2);
    position: absolute;
    left: calc(50% - 100px);
    z-index: 10;
    display: none;
  }

  .svg-button-camera {
    width: 200px;
    color: white;
    font-size: 16px;
    border: none;
    text-align: center;
    position: fixed;
    bottom: 154px;
    left: calc(50% - 100px);
    z-index: 10;
    padding: 5px 60px;
    cursor: pointer;
  }

  #box--loading {
    position: absolute;
    width: 100%;
    top: 50%;
  }

  audio,
  canvas,
  video {
    display: inline-block;
    *display: inline;
    *zoom: 1;
    max-width: 100%;
  }

  .taken {
    height: 100px !important;
    width: 100px !important;
    transition: all 0.5s ease-in;
    border: solid 3px white;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2);
    top: 20px;
    right: 20px;
    z-index: 2;
  }
}

</style>


// WEBPACK FOOTER //
// camera.vue?381e3d5e